import * as actions from '../actions/currentToastActionTypes';


const initialState = {
  toastStack: []
}

function currentToast(state =initialState, action) {
  switch (action.type) {    
    case actions.CURRENT_TOAST_ADD:      
      return {
        ...state,         
        toastStack: action.toastStack
      }
    case actions.CURRENT_TOAST_CLEAR:
        return {
          ...state, 
          toastStack: null
        }     
    default:
      return state
  } 
}

export default currentToast